<template>
	<div class="inputBoxWrap">
		<suggestions
        v-model="value"
        :options="options"
        :onInputChange="onInputChange"
        :onItemSelected="onSearchItemSelected"
    >
      <div
          slot="item"
          slot-scope="props"
          class="single-item"
      >
        <span
            class="name"
        >
          {{props.item.value}}
        </span>
      </div>
		</suggestions>
		<label>{{item.label}}</label>
		<p
        class="errorMsg"
        v-if="statusVuex[refs].ShowError"
    >
      {{errorMsg}}
    </p>
	</div>
</template>
<script>
import 'v-suggestions/dist/v-suggestions.css';
import DataForInput from '@/store/Form/longFormOptions';
import {mapState} from 'vuex';
export default {
	name: "vmSelectDadata",
	props:{
    refs: {
      type: String,
      default: 'null'
    },
  },
	data() {
		return {
			query:'',
			selectedCountry: null,
			selectedSearchItem: null,
			options: { placeholder: DataForInput[this.refs].placeholder, },
			item: DataForInput[this.refs],
		}
	},
	computed:{
		...mapState({
      statusVuex: state => state.Form.workData,
      valueVuex: state => state.Form.sendData,
    }),
		value:{
			get() {
        return this.valueVuex[this.refs]
      },
			set(value) {
        let utiputi = {
          target:this.refs,
          value: value
        };
        this.$store.dispatch('saveSendData',utiputi);
      }
		},
		errorMsg() {
      return this.statusVuex[this.refs].msg;
      },
	},
	components: {
    suggestions: ()=>import('v-suggestions')
  },
	methods:{
		onInputChange () {
      // Не стал опираться на this.refs до лучших времён. Всё-таки этот инпут именно на паспорт
      let searchOption = '';
      if (this.valueVuex['PASSPORT_DEP_CODE'].length > 0) {
        searchOption = this.valueVuex['PASSPORT_DEP_CODE']
      } else {
        if (this.valueVuex['PASSPORT_DEP'].length > 0) {
          searchOption = this.valueVuex['PASSPORT_DEP']
        }
      }
			return new Promise(resolve => {
				this.$myApi.suggestResult(
            this.refs,
            {
              'value': searchOption,
              'type': this.refs
            }
        ).then(resp => {
          let dadataSuggest = resp.data.result.suggestions;
					let result = (Array.isArray(dadataSuggest) && dadataSuggest.length) ? dadataSuggest : [];
					resolve(result);
				});
			});
		},
		onSearchItemSelected (item) {
			this.$palantir.trackInputBlur(this.refs, item.value);
			this.selectedSearchItem = item;
			this.query = item.value;
			this.$store.dispatch('saveSendData',{ target: 'PASSPORT_DEP', value: item.value });
			this.$store.dispatch('saveSendData',{ target: 'PASSPORT_DEP_CODE', value: item.data.code });
		},
	},
}
</script>
<style scoped>
.errorMsg { color: red; font-size: 3.24vw; pointer-events: none;position: absolute; background: white;padding: 0 1.60vw; top: 11vw; left: 2.28vw }
/deep/ .v-suggestions > input { border: 1px solid rgba(67, 172, 52, 0.5); padding: 4.41vw 5.88vw 4.41vw 5.88vw; margin-bottom: 4.71vw; font-size: 3.47vw; border-radius: 2.67vw }
/deep/ .v-suggestions .name { font-size: 3.47vw }
.inputBoxWrap { position: relative }
.inputBoxWrap label { position: absolute; padding: 0 2.67vw ; top: 1px; font-size: 2.87vw; border-top-left-radius: 2.67vw; color: #869A95; pointer-events: none; transition: 0.3s ease-out; background: #FFFFFF; left: 2.28vw}
input:focus ~ label { top: -2vw }
@media (min-width: 760px) {
  .errorMsg { font-size: 0.81vw; top: 2.8vw; left: 0.28vw; }
  /deep/ .v-suggestions > input { padding: 0.89vw 1.61vw; border-radius: 10px; font-size: 1.13vw; margin-bottom: 1.29vw; color: #959595 }
  /deep/ .v-suggestions .name{ font-size: 1.29vw }
  .inputBoxWrap label { font-size: 0.81vw; color: #959595; padding: 0}
}
@media (min-width: 1240px) {
  .errorMsg { font-size: 10px; top: 36px; left: 23px }
  /deep/ .v-suggestions > input { padding: 18px 26px; font-size: 14px; margin-bottom: 16px }
  /deep/ .v-suggestions .name { font-size: 14px }
  .inputBoxWrap label { font-size: 0.81vw; color: #959595; padding: 0}
}
</style>
